import Wreqr from 'backbone.wreqr'

var vent = new Wreqr.EventAggregator();

vent.commands = new Wreqr.Commands();
vent.reqres = new Wreqr.RequestResponse();

export default vent;

